module.exports = __webpack_public_path__ + "img/desc2.b1231351.png";